<script setup lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import NavProgressBar from '@/components/NavProgressBar.vue'

const { locale } = useI18n()
watch(locale, (lang) => { document.documentElement.lang = lang }, { immediate: true })
</script>

<template>
  <NavProgressBar />
  <RouterView />
</template>
